import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type { GestaoFluxoApi } from './GestaoFluxoApi';
import type { RespostaDados } from '../types';

/**
 * Cliente do backend plugin.
 *
 * O SQL roda no backend, então nada de credencial nem de consulta chega ao
 * navegador. O fetchApi do Backstage anexa o token do usuário, e é ele que
 * autentica a chamada: o endpoint devolve título de atividade, pessoa e
 * repositório, e não deve ficar aberto.
 */
export class GestaoFluxoClient implements GestaoFluxoApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async buscarDados(): Promise<RespostaDados> {
    const base = await this.discoveryApi.getBaseUrl('gestao-fluxo');
    const res = await this.fetchApi.fetch(`${base}/dados`, {
      headers: { Accept: 'application/json' },
    });

    if (!res.ok) {
      // O backend devolve { error } com a mensagem do banco, que é o que de
      // fato ajuda a diagnosticar. ResponseError preserva esse corpo.
      throw await ResponseError.fromResponse(res);
    }

    return (await res.json()) as RespostaDados;
  }
}
